import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, take, tap } from 'rxjs';
import { HttpUtilsService } from 'src/app/core/_base/crud';
import { CrudService } from 'src/app/shared/crud/crud.service';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrl + '/configurations';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService extends CrudService<any> {
  public companySubject = new BehaviorSubject<any>(null);

  constructor(
    protected http: HttpClient,
    protected httpUtils: HttpUtilsService
  ) {
    super(API_URL, http, httpUtils);
  }

  resolveCompany(params = {}) {
    return this.http.get(API_URL, { params }).pipe(
      tap((res: any) => {
        this.companySubject.next(res['hydra:member'][0]);
      })
    );
  }

  updateGeneralSettings(id: string, settings: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
      Accept: 'application/ld+json',
    });

    return this.http
      .patch(`${API_URL}/${id}/general-settings`, settings, { headers })
      .pipe(
        take(1),
        tap((res: any) => this.companySubject.next(res))
      );
  }
}
